﻿window.cognoss = function(bddRef) {

    //parametre.lst_appli_maitre
    this.dsAppli = JSON.parse(JSON.stringify(parametre.lst_appli_maitre))
    this.dsAppli.forEach(function (appli) {
        appli.bcAppli = bddRef.mGetArray("bc_appli").filter(function (app) { return app.code_appli == appli.code_appli })[0]
        if (typeof appli.bcAppli == 'undefined') {
            appli.bcAppli = bddRef.getObjet("bc_appli").mGetNewData()
            appli.bcAppli.nom_appli = appli.nom
            appli.bcAppli.code_appli = appli.code_appli
            bddRef.getObjet(appli.bcAppli).mSave()
        }
    })
    this.dsAppli.unshift({ code_appli: "", nom: "(Tous)" })

    //this.dsAppli = JSON.parse(JSON.stringify(bddRef.mGetArray("bc_appli")))
    //this.dsAppli.unshift({ id_bc_appli: 0, nom_appli: "(Tous)" })
    //this.dsAppli.forEach(function (appli) {
    //    appli.detail = parametre.lst_appli_maitre.filter(function (app) { return app.code_appli == appli.code_appli })[0]
    //})

    this.mGetTitlePage = function () {
        if (gestCognoss.isAdmin()) { return "Cognoss" }
        else { "Aide " + gestCognoss.mGetAppliCourante().nom }
    }

    this.mGetDsAppliWithoutNull = function () {
        var dsAppliSansNull = JSON.parse(JSON.stringify(this.dsAppli))
        dsAppliSansNull.splice(0, 1)
        return dsAppliSansNull
    }

    this.isReadOnly = function () {
        if (parametre.code_appli == "cog") {
            //on est dans cognoss
            if (typeof bddRef.utiCnx != 'undefined' && bddRef.utiCnx != null) {
                //on a un utilisateur
                //on est en modification
                return false
            } else {
                //on a pas d'utilisateur, on est sur quelqu'un qui veux voir l'aide sur une appli
                return true
            }
        } else {
            //on est dans une appli
            return false
        }
    }

    this.isAdmin = function () {
        if (parametre.code_appli == "cog") {
            return (typeof bddRef.utiCnx != 'undefined' && bddRef.utiCnx != null)
        } else {
            return false
        }
    }

    this.afficheSelectAppli = function () {
        if (parametre.code_appli == "cog") {
            //on est dans cognoss
            if (typeof bddRef.utiCnx != 'undefined' && bddRef.utiCnx != null) {
                //on a un utilisateur
                //on est en modification
                //afficher la sélection d'appli
                return true
            } else {
                //on a pas d'utilisateur, on est sur quelqu'un qui veux voir l'aide sur une appli
                return false
            }
        } else {
            //on est dans une appli
            //on affiche pas la sélection d'appli
            return false
        }
    }


    //code_appli_consult
    this.mGetAppliCourante = function () {
        if (parametre.code_appli == "cog") {
            //on est dans cognoss
            if (typeof bddRef.utiCnx != 'undefined' && bddRef.utiCnx != null) {
                //on a un utilisateur
                //on est en modification
                //afficher la sélection d'appli
                var app = null
                this.dsAppli.forEach(function (item) {
                    if ( item.code_appli == "cog") app = item
                })
                return app
            } else {
                //on a pas d'utilisateur, on est sur quelqu'un qui veux voir l'aide sur une appli
                //https://aide.invitto.eu
                //https://localhost/masc
                    //code_appli_consult
                var app = null
                this.dsAppli.forEach(function (item) {
                    if (item.code_appli == code_appli_consult) app = item
                })
                //var nomAppli = getUrlParameter("nom_appli")
                //if (app == null && nomAppli != null) {
                //    this.dsAppli.forEach(function (item) {
                //        if (typeof item.detail != 'undefined' && item.detail.nom.toLowerCase() == nomAppli) app = item
                //    })
                //}
                return app
            }
        } else {
            //on est dans une appli
            var app = null
            this.dsAppli.forEach(function (item) {
                if (parametre.code_appli.startsWith(item.code_appli)) app = item
            })
            return app
        }
    }

    //retourne si on est dans une app (en dehors de cognoss)
    this.isInApp = function () {
        return (parametre.code_appli != "cog")
    }

    this.afficheTicket = function () {
        if (parametre.code_appli == "cog") {
            //on est dans cognoss
            if (typeof bddRef.utiCnx != 'undefined' && bddRef.utiCnx != null) {
                //on a un utilisateur
                //on est en modification
                //affiche pas les tickets
                return false
            } else {
                //on a pas d'utilisateur, on est sur quelqu'un qui veux voir l'aide sur une appli
                return true
            }
        } else {
            //on est dans une appli
            //on affiche pas la sélection d'appli
            return false
        }
    }

    this.afficheDeconnexionBoxCorbeille = function () {
        return (parametre.code_appli == "cog" && typeof bddRef.utiCnx != 'undefined' && bddRef.utiCnx != null)
    }

    //this.mGetUrlImgBackGround = function () {
    //    return this.mGetAppliCourante().url_img_entete_cognoss
    //}

}